import { render, staticRenderFns } from "./ChivasLounge.vue?vue&type=template&id=3a6da7d6&scoped=true"
import script from "./ChivasLounge.vue?vue&type=script&lang=js"
export * from "./ChivasLounge.vue?vue&type=script&lang=js"
import style0 from "./ChivasLounge.vue?vue&type=style&index=0&id=3a6da7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6da7d6",
  null
  
)

export default component.exports